import { types } from './actions';

const initialState = {
  conformanceLanguage: null,
  isConformanceLanguageSaving: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.CONFORMANCE_LANGUAGE_FETCH_SUCCESS:
      return {
        ...state,
        conformanceLanguage: payload.conformanceLanguage,
      };
    case types.CONFORMANCE_LANGUAGE_UPDATE_ERROR:
      return {
        ...state,
        isConformanceLanguageSaving: false,
      };
    case types.CONFORMANCE_LANGUAGE_UPDATE_REQUEST:
      return {
        ...state,
        isConformanceLanguageSaving: true,
      };
    case types.CONFORMANCE_LANGUAGE_UPDATE_SUCCESS:
      return {
        ...state,
        conformanceLanguage: payload.conformanceLanguage,
        isConformanceLanguageSaving: false,
      };

    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.company.conformanceLanguage;

export const getConformanceLanguage = (state) =>
  getScope(state).conformanceLanguage;

export const isConformanceLanguageSaving = (state) =>
  getScope(state).isConformanceLanguageSaving;
